 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		13: 0,
 		6: 0,
 		7: 0,
 		8: 0,
 		70: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		13: 0,
 		6: 0,
 		7: 0,
 		8: 0,
 		70: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSe~23538779","1":"vendors~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSe~ffd0fef2","2":"route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSettings~r~45a4aed9","3":"vendors~route-MapView~route-adminCameraSettings~route-album~route-habitat~route-habitats~route-highl~8cd8e8f4","4":"vendors~route-MapView~route-habitat~route-habitats~route-highlights~route-home~route-myAlbum~route-schedule","5":"vendors~route-MapView~route-habitat~route-habitats~route-highlights~route-home~route-myAlbum","10":"route-account~route-login","11":"route-adminUsers~route-schedule","12":"route-reports~route-schedule","16":"route-MapView","17":"route-TermsAndPrivacy","18":"route-account","19":"route-adminAdvertisements","20":"route-adminAnnouncements","21":"route-adminCameraInfo","22":"route-adminCameraSettings","23":"route-adminConfigurations","24":"route-adminHabitats","25":"route-adminOnlineUsersInfo","26":"route-adminPartners","27":"route-adminPlaylists","28":"route-adminTestNewModelsForAiKeeper","29":"route-adminUsers","30":"route-album","31":"route-emailVerify","32":"route-feed","33":"route-gift","34":"route-habitat","35":"route-habitats","36":"route-help","37":"route-highlights","38":"route-home","39":"route-importBundleUsers","40":"route-login","41":"route-myAlbum","42":"route-notFound","43":"route-notifications","44":"route-passwordReset","45":"route-plans","46":"route-profile","47":"route-redeem","48":"route-reports","49":"route-schedule","50":"route-signup","51":"route-socialLogin","52":"route-softReload","53":"route-talkSchedule","54":"route-welcome"}[chunkId]||chunkId) + ".chunk." + {"0":"27efe","1":"b06ac","2":"10fe1","3":"91f85","4":"f7b4b","5":"bf847","6":"e73b7","7":"7030d","8":"888b1","9":"31705","10":"77749","11":"2d00c","12":"d6ab4","16":"993b1","17":"7b4d8","18":"b2c42","19":"f1368","20":"8b438","21":"07539","22":"e9aad","23":"46fc1","24":"94eb9","25":"f39cc","26":"20624","27":"103a0","28":"18428","29":"788bc","30":"0ee71","31":"3f67d","32":"16929","33":"c7a15","34":"561a5","35":"93d18","36":"00e40","37":"c2a4b","38":"d0e59","39":"84bea","40":"589d7","41":"8e9d1","42":"47a4c","43":"0b1c5","44":"567f6","45":"59107","46":"fd99f","47":"af302","48":"92acc","49":"caf5d","50":"88b7d","51":"ff6a2","52":"1285d","53":"4c48f","54":"21258","55":"fc5e3","56":"28c0c","57":"15f37","58":"0370a","59":"99b18","60":"c9e92","61":"a2284","62":"2b9d5","63":"44395","64":"8bc01","65":"b4e1f","66":"eb9f6","67":"1b7f4","68":"6ebee","69":"aa523","71":"61637","72":"8482d","73":"b1487","74":"9801d"}[chunkId] + ".esm.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"10":1,"11":1,"16":1,"18":1,"22":1,"24":1,"26":1,"29":1,"30":1,"31":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"40":1,"41":1,"42":1,"44":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"53":1,"55":1,"56":1,"57":1,"58":1,"61":1,"62":1,"63":1,"64":1,"66":1,"68":1,"69":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSe~23538779","1":"vendors~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSe~ffd0fef2","2":"route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSettings~r~45a4aed9","3":"vendors~route-MapView~route-adminCameraSettings~route-album~route-habitat~route-habitats~route-highl~8cd8e8f4","4":"vendors~route-MapView~route-habitat~route-habitats~route-highlights~route-home~route-myAlbum~route-schedule","5":"vendors~route-MapView~route-habitat~route-habitats~route-highlights~route-home~route-myAlbum","10":"route-account~route-login","11":"route-adminUsers~route-schedule","12":"route-reports~route-schedule","16":"route-MapView","17":"route-TermsAndPrivacy","18":"route-account","19":"route-adminAdvertisements","20":"route-adminAnnouncements","21":"route-adminCameraInfo","22":"route-adminCameraSettings","23":"route-adminConfigurations","24":"route-adminHabitats","25":"route-adminOnlineUsersInfo","26":"route-adminPartners","27":"route-adminPlaylists","28":"route-adminTestNewModelsForAiKeeper","29":"route-adminUsers","30":"route-album","31":"route-emailVerify","32":"route-feed","33":"route-gift","34":"route-habitat","35":"route-habitats","36":"route-help","37":"route-highlights","38":"route-home","39":"route-importBundleUsers","40":"route-login","41":"route-myAlbum","42":"route-notFound","43":"route-notifications","44":"route-passwordReset","45":"route-plans","46":"route-profile","47":"route-redeem","48":"route-reports","49":"route-schedule","50":"route-signup","51":"route-socialLogin","52":"route-softReload","53":"route-talkSchedule","54":"route-welcome"}[chunkId]||chunkId) + ".chunk." + {"0":"31d6c","1":"31d6c","2":"1d267","3":"31d6c","4":"31d6c","5":"31d6c","6":"31d6c","7":"31d6c","8":"31d6c","9":"31d6c","10":"88da0","11":"ca957","12":"31d6c","16":"ff257","17":"31d6c","18":"7a826","19":"31d6c","20":"31d6c","21":"31d6c","22":"60af3","23":"31d6c","24":"b36ec","25":"31d6c","26":"95288","27":"31d6c","28":"31d6c","29":"f7a5c","30":"9c613","31":"7990d","32":"31d6c","33":"c8982","34":"6cb08","35":"eab88","36":"3a1a1","37":"68e7b","38":"4e8b6","39":"31d6c","40":"55fd1","41":"47ba8","42":"0e780","43":"31d6c","44":"5255f","45":"cfcea","46":"8c877","47":"a3247","48":"576ae","49":"5eb5c","50":"3a45d","51":"31d6c","52":"31d6c","53":"ba6f8","54":"31d6c","55":"1e8d3","56":"934b9","57":"05a6c","58":"9abce","59":"31d6c","60":"31d6c","61":"91d99","62":"91d99","63":"c75d8","64":"65381","65":"31d6c","66":"91d99","67":"31d6c","68":"3c18c","69":"39184","71":"31d6c","72":"31d6c","73":"31d6c","74":"31d6c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = "brot");
